import { render, staticRenderFns } from "./instVideoCall.vue?vue&type=template&id=fe744174&scoped=true"
import script from "./instVideoCall.vue?vue&type=script&lang=js"
export * from "./instVideoCall.vue?vue&type=script&lang=js"
import style0 from "./instVideoCall.vue?vue&type=style&index=0&id=fe744174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe744174",
  null
  
)

export default component.exports